import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";

import { ForgeModule } from "@tylertech/forge-angular";

import { LgdTypeAheadComponent, HighlightPipe } from "./lgdTypeAhead.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatAutocompleteModule,
        ForgeModule,
    ],
    declarations: [
        LgdTypeAheadComponent,
        HighlightPipe
    ],
    exports: [
        ReactiveFormsModule,
        LgdTypeAheadComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LgdTypeAheadModule { }
